import { getRecoil, setRecoil } from 'recoil-nexus';

import {
  ambientListeningIntelligenceChatId,
  currentActiveStepID,
  emCPTsText,
  enhanceAmbientListeningLoading,
  enhancedNote,
  preSelectedNoteType
} from 'components/practice/charts/ClinicalNote/MyScribeAI/Templates/AmbientListening/state';

// Track the last processed intelligence_chat_id to ignore duplicate responses
let lastProcessedChatId = null;

const updateAmbientListening = (data) => {
  const { done = false, abort = false, note, noteType, emCPTsText: emCodesText, ...rest } = data;

  try {
    if (rest?.intelligence_chat_id) {
      setRecoil(ambientListeningIntelligenceChatId, rest?.intelligence_chat_id);
    }

    if (done || abort) {
      const isLoading = getRecoil(enhanceAmbientListeningLoading);

      // If loading is already false, a previous response already handled this —
      // skip to avoid overwriting user's current state (e.g., step changes)
      if (!isLoading) {
        // Still allow the first response for a new chat to update the note data,
        // but only if it's a different intelligence_chat_id
        if (rest?.intelligence_chat_id && rest.intelligence_chat_id === lastProcessedChatId) {
          return;
        }
      }

      lastProcessedChatId = rest?.intelligence_chat_id || null;

      setRecoil(preSelectedNoteType, noteType);
      setRecoil(enhanceAmbientListeningLoading, false);
      setRecoil(enhancedNote, note);
      setRecoil(emCPTsText, emCodesText);

      // Only change step if we were actually in loading state
      // This prevents duplicate responses from overriding user navigation
      if (isLoading) {
        if (abort) {
          setRecoil(currentActiveStepID, 2);
        } else {
          setRecoil(currentActiveStepID, 3);
        }
      }
    }
  } catch (error) {
    console.error('❌ Error', error);
  }
};

export default updateAmbientListening;
